/**
 * MBA Lab — the Listening Session Facilitator's reference card and prep/
 * reflection prompts. Pure data, no functions, matching readiness-
 * dimensions.js's precedent. BEHAVIORS reuses this site's own already-
 * published, original content from Content/Leadership/empathetic-listening-
 * skills.md - not POC-derived, and consistent with what that article already
 * teaches rather than re-deriving new phrasing for the same 5 behaviors.
 */

export const BEHAVIORS = Object.freeze([
  { key: 'feeling', text: 'Listen for the feeling, not just the facts.' },
  { key: 'reflect', text: 'Reflect back what you heard, in your own words, before responding to it.' },
  { key: 'ask', text: 'Ask a real question instead of offering a fix.' },
  { key: 'notice', text: "Notice when you've stopped listening and started rehearsing your reply." },
  { key: 'pause', text: 'Tolerate a pause instead of filling it.' },
]);

export const PREPARE_FIELDS = Object.freeze([
  {
    key: 'goal',
    label: 'What do you want to understand better by the end of this conversation?',
  },
  {
    key: 'hardToHear',
    label: 'What might make this hard to hear?',
  },
]);

export const REFLECT_FIELDS = Object.freeze([
  {
    key: 'unexpected',
    label: "What did you hear that you didn't expect?",
  },
  {
    key: 'differently',
    label: 'What will you do differently because of this conversation?',
  },
  {
    key: 'followUp',
    label: 'Is there anything you need to follow up on?',
  },
]);
